function initTestimonialsSlider() {
  $(document).on('click', '.slide-btns .slide-btn', function () {
    const dir = $(this).data('dir');
    let currentActive = $('.slide.active').data('index');
    const maxPage = $('.slide').length;
    $('.slide').removeClass('active');

    if (dir === 'next') {
      currentActive = maxPage <= currentActive + 1 ? 0 : currentActive + 1;
    } else {
      currentActive = currentActive - 1 <= 0 ? maxPage - 1 : currentActive - 1;
    }

    $(`.slide[data-index="${currentActive}"]`).addClass('active');
  });
}

export default {
  init() {
    initTestimonialsSlider();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
